import { useNavigate } from "react-router-dom";
import BackButton from "../../common/components/BackButton";
import FormBuilder from "../../common/components/formInputs/FormBuilder";
import useComponents from "../../common/hooks/pages/useComponents";
import useIncidents from "../../common/hooks/pages/useIncidents";
import { useMutation } from "react-query";
import { useEffect, useState } from "react";
import Select from "react-select";
import { usePopup } from "../../common/contexts/PopupContext";

function IncidentUpdateForm({ onSubmit, isSubmitting, incident, id }) {
  const navigate = useNavigate();
  const { getIncidentStatusTypes, updateIncident, updateBackfillIncident } =
    useIncidents();
  const { getComponents, getComponentStatusTypes } = useComponents();

  const [incidentStatus, setIncidentStatus] = useState([]);
  const [components, setComponents] = useState([]);
  const [componentstatus, setComponentstatus] = useState([]);
  const [backfill, setBackfill] = useState(false);
  const [notify, setNotify] = useState(false);
  const [componentarr, setComponentarr] = useState([]);

  const [name, setName] = useState("");
  const [incistatus, setIncistatus] = useState("");
  const [message, setMessage] = useState("");
  const [date, setDate] = useState("");
  const [time, setTime] = useState("");
  const [notification, setNotification] = useState(false);
  const [remainder, setRemainder] = useState(false);
  const [affectedcomponents, setAffectedcomponents] = useState([]);
  const [placeholder, setPlaceholder] = useState("Message");

  const { toast } = usePopup();

  const { mutate: updateIncidentMutate } = useMutation({
    mutationFn: updateIncident,
    onSuccess: (res) => {
      const { message } = res?.data || {};

      toast(message, "success");

      navigate("/view_incidents");
    },
    onError: (error) => {
      const message =
        error?.response?.data?.message ||
        "Something went wrong while creating Incident!";
      toast(message, "error");
    },
  });

  const { mutate: updateBackfillIncidentMutate } = useMutation({
    mutationFn: updateBackfillIncident,
    onSuccess: (res) => {
      const { message } = res?.data || {};

      toast(message, "success");

      navigate("/view_incidents");
    },
    onError: (error) => {
      const message =
        error?.response?.data?.message ||
        "Something went wrong while creating Incident!";
      toast(message, "error");
    },
  });

  const {
    mutate: getIncidentStatus,
    data,
    isLoading: isCreating,
  } = useMutation({
    mutationFn: getIncidentStatusTypes,
    onSuccess: (res) => {},
    onError: (error) => {
      const message =
        error?.response?.data?.message ||
        "Something went wrong while creating component!";
    },
  });

  const {
    mutate: get_Components,
    data: records,
    isLoading: isCreate,
  } = useMutation({
    mutationFn: getComponents,
    onSuccess: (res) => {},
    onError: (error) => {
      const message =
        error?.response?.data?.message ||
        "Something went wrong while creating component!";
    },
  });

  const {
    mutate: getComponentStatus,
    data: status,
    isLoading: isCreates,
  } = useMutation({
    mutationFn: getComponentStatusTypes,
    onSuccess: (res) => {},
    onError: (error) => {
      const message =
        error?.response?.data?.message ||
        "Something went wrong while creating component!";
    },
  });

  useEffect(() => {
    getIncidentStatus();
    get_Components();
    getComponentStatus();
    if (incident) {
      setIncidentStatus(data?.data?.incidentStatusTypes);
      setComponentstatus(status?.data.componentStatusTypes);
      setComponents(records?.data?.components);
      setName(incident?.name || "");
      if (incident?.notify == "false") {
        setNotification(false);
      } else {
        setNotification(true);
      }
      setRemainder(incident?.remainder);

      const lastUpdateIndex = incident?.updates.length - 1;
      if (lastUpdateIndex >= 0) {
        const lastUpdate = incident.updates[lastUpdateIndex];
        setIncistatus(lastUpdate.status._id);
        setMessage(lastUpdate.message || "");
        setAffectedcomponents(lastUpdate.affectedComponents);
        setBackfill(incident?.backfill);
        const dateTime = new Date(lastUpdate.happenedAt);
        const date = dateTime.toISOString().split("T")[0];
        const time = dateTime.toLocaleTimeString();
        setDate(date);
        setTime(time);
      }
    }
  }, [incident]);
  function checkedHandler(e) {
    if (e.target.checked) {
      setBackfill(true);
    } else {
      setBackfill(false);
    }
  }

  function incidentHandler(e) {
    setIncistatus(e._id);
    if (e.label === "Identified") {
      setMessage(
        "The issue has been identified and a fix is being implemented."
      );
    } else if (e.label === "Investigating") {
      setMessage("We are currently investigating this issue.");
    } else if (e.label === "Monitoring") {
      setMessage(
        "A fix has been implemented and we are monitoring the results."
      );
    } else if (e.label === "Resolved") {
      setMessage("This incident has been resolved.");
    }
  }

  const submitHandler = (e) => {
    e.preventDefault();
    let updatedMessage = message || placeholder;
    setMessage(updatedMessage);

    if (backfill) {
      updateBackfillIncidentMutate({
        id: id,
        name: name,
        message: updatedMessage,
        incidentDate: date,
        time: time,
      });
    } else {
      updateIncidentMutate({
        id: id,
        name: name,
        status: incistatus,
        message: updatedMessage,
        components: componentarr,
        notification: notification,
        remainder: remainder,
      });
    }
  };

  return (
    <div>
      <div className="flex justify-between items-center pb-8 border-b">
        <div className="text-2xl font-bold">Update Incident</div>
        <BackButton onClick={() => navigate("/view_incidents")}>
          Back to Incidents
        </BackButton>
      </div>
      <form className="space-y-6" onSubmit={submitHandler}>
        <div className={`my-4 }`}>
          <div className="pb-1 text-gray-800">Incident name</div>
          <input
            type="text"
            defaultValue={name}
            onChange={(e) => setName(e.target.value)}
            className={`px-2 py-2 rounded-md border-2 border-gray-300 outline-none focus:ring-2  transition ease-in-out delay-150 w-full 
        }`}
            required
          />

          {!backfill && (
            <div className="my-4">
              <div className="pb-1 text-gray-800">Incident status</div>
              <Select
                options={incidentStatus}
                onChange={incidentHandler}
                value={incidentStatus.filter(
                  (option) => option._id === incistatus
                )}
              />
            </div>
          )}
          {!backfill && (
            <div className={`my-4 `}>
              <div className="pb-1 text-gray-800">Message</div>
              <textarea
                type="text"
                className={`px-2 py-2 rounded-md border-2 border-gray-300 outline-none focus:ring-2 transition ease-in-out delay-150 w-full`}
                rows={4}
                cols={50}
                defaultValue={message}
                onChange={(e) => setMessage(e.target.value)}
                placeholder={placeholder}
              />
            </div>
          )}
          {!backfill && (
            <div className={`my-4 `}>
              <div className="pb-1 text-gray-800">Components affected</div>
              <hr />
              {components?.map((record, i) => {
                return (
                  <AffectedItems
                    record={record}
                    options={componentstatus}
                    componentarr={componentarr}
                    setComponentarr={setComponentarr}
                    affectedcomponents={affectedcomponents}
                  />
                );
              })}
            </div>
          )}
          {!backfill && (
            <div className={`my-4 }`}>
              <hr />
              <br />
              <div className="pb-1 text-gray-800">Notifications</div>
            </div>
          )}
          {!backfill && (
            <div className={`my-1 ${notify && "is-disabled"}`}>
              <input
                type="checkbox"
                onChange={(e) => setNotification(e.target.checked)}
                checked={notification}
              />
              <span className="pb- text-gray-800 incident_checkbox">
                Send Notifications
              </span>
            </div>
          )}

          {backfill && (
            <div className={`my-4 `}>
              <div className="pb-1 text-gray-800">Incident date (GMT-5:30)</div>
              <input
                type="date"
                defaultValue={date}
                onChange={(e) => setDate(e.target.value)}
                className={`px-2 py-2 rounded-md border-2 border-gray-300 outline-none focus:ring-2 transition ease-in-out delay-150 w-1/2`}
              />
              <input
                type="time"
                value={time}
                onChange={(e) => setTime(e.target.value)}
                className={`px-2 py-2 rounded-md border-2 border-gray-300 outline-none focus:ring-2 transition ease-in-out delay-150 w-1/2`}
              />
            </div>
          )}
          {backfill && (
            <div className={`my-4 `}>
              <div className="pb-1 text-gray-800">Message</div>
              <textarea
                type="text"
                className={`px-2 py-2 rounded-md border-2 border-gray-300 outline-none focus:ring-2 transition ease-in-out delay-150 w-full`}
                rows={4}
                cols={50}
                placeholder="Message"
                defaultValue={message}
                onChange={(e) => setMessage(e.target.value)}
              />
            </div>
          )}
        </div>
        <br />
        <div className={`my-16 !w-fit `}>
          <button
            type="submit"
            className={`rounded-md common_bg text-white w-full px-4 py-2 nav_link-500 transition ease-in-out duration-300
          }`}
          >
            Update an Incident
            <div className="flex justify-center items-center"></div>
          </button>
        </div>
        <br />
      </form>
    </div>
  );
}

export default IncidentUpdateForm;

const AffectedItems = ({
  record,
  options,
  componentarr,
  setComponentarr,
  affectedcomponents,
}) => {
  const [checked, setChecked] = useState(false);
  const [componentval, setComponentval] = useState(record._id);
  const [statusVal, setStatusVal] = useState("");

  useEffect(() => {
    const foundComponent = affectedcomponents.find(
      (item) => item.component === record._id
    );
    if (foundComponent) {
      setChecked(true);
      setStatusVal(foundComponent.componentStatus._id);
      componentarr.push({
        component: record._id,
        status: foundComponent.componentStatus._id,
      });
    }
  }, []);

  const onStatusHandler = (e) => {
    const index = componentarr.findIndex(
      (item) => item.component === componentval
    );
    if (index !== -1) {
      componentarr[index] = {
        component: componentval,
        status: e._id,
      };
    } else {
      componentarr.push({ component: componentval, status: e._id });
    }
  };

  const onChangeHandler = (e) => {
    setChecked(e.target.checked);
    if (!e.target.checked) {
      const index = componentarr.findIndex(
        (item) => item.component === e.target.id
      );
      if (index !== -1) {
        componentarr.splice(index, 1);
        setStatusVal("");
      }
    }
  };

  return (
    <div className="grid grid-cols-3 gap-4">
      <div className="my-4" key={record._id}>
        <input
          name="affectedcomponents"
          type="checkbox"
          id={record._id}
          onChange={onChangeHandler}
          checked={checked}
        />
        <span className="pb-1 text-gray-800 incident_checkbox">
          {record.name}
        </span>
      </div>
      {checked && (
        <div className="col-md-4">
          <Select
            options={options}
            onChange={onStatusHandler}
            className="min-w-48 component_status"
            defaultValue={options.find((option) => option._id === statusVal)}
          />
        </div>
      )}
    </div>
  );
};
